<template>
  <div class="atlas-social-announcement">
    <!-- Standard page header -->
    <div class="standard-page-header standard-page-header--no-bottom-line atlas-social-announcement__header">
      <h2 class="global-h2 standard-page-header__title">
        <RouterLink :to="{ name: 'CalendarPosts', params: { customerId: props.customerId } }"> Try Atlas Social Today!</RouterLink>
      </h2>

      <div class="standard-page-header__subtitle-and-link">
        <div class="standard-page-header__subtitle">Get started with our new Atlas Social content calendar and unlock the power of AI-powered content creation.</div>
      </div>
    </div>
    <!-- / Standard page header -->

    <SrpButton class="atlas-social-announcement__cta" tag="RouterLink" :color="buttonColor" :to="{ name: 'CalendarPosts', params: { customerId: props.customerId } }"> Try it out </SrpButton>
  </div>
</template>

<script setup lang="ts">
import SrpButton, { SrpButtonColor } from "@components/ui/SrpButton.vue";

const props = withDefaults(
  defineProps<{
    customerId: string;
    buttonColor?: SrpButtonColor;
  }>(),
  {
    customerId: "",
    buttonColor: "teal",
  }
);
</script>

<style scoped lang="scss">
@import "@/scss/screen-size-ranges.scss";

.atlas-social-announcement {
  &__header {
    margin-bottom: 15px;
  }

  &__cta {
    margin-bottom: 20px;
  }
}
</style>
